// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#settings {\n  height: 100%;\n}\n#settings .el-tabs__item {\n  font-weight: 700;\n}", ""]);
// Exports
module.exports = exports;
